import { render, staticRenderFns } from "./RootHeader.vue?vue&type=template&id=dd2da5b0&scoped=true&"
import script from "./RootHeader.vue?vue&type=script&lang=js&"
export * from "./RootHeader.vue?vue&type=script&lang=js&"
import style0 from "./RootHeader.vue?vue&type=style&index=0&id=dd2da5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2da5b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VCol,VList,VListItem,VListItemTitle,VMenu,VRow,VTab,VTabs,VTabsSlider})
